
import { getObjProperty } from '@utilities/mrVueUtils';

const state = {
  openChatData: {
    eventName: null,
  },
};

const getters = {
  implementationName(state, getters, rootState) {
    let experiments = getObjProperty(rootState, 'global.experiments');

    if (!Object.keys(experiments).length) {
      return null;
    }

    let experimentVersion = experiments['GladlyIntegrationLaunch'] || 'A';
    let implementations = { A: 'zendesk', B: 'gladly' };
    return implementations[experimentVersion];
  },
};

export const mutations = {
  setDataForOpeningChat(state, data = {}) {
    let actualData = { ...data };
    state.openChatData = { eventName: actualData.eventName };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
